import React, { Fragment, useEffect, useState } from 'react'
import { Button, Card, CardHeader, CardTitle, Col, Input, Label, Row } from "reactstrap";
import AreaFilter from "../area/components/filter-area/area-filter";
import { width } from '@mui/system';

const initialFilterProps = {
    'title': '',
    'template': '',
    'clientIdentification': '',
    'clientEmail': '',
    'clientPhone': '',
    'clientName': '',
    'companyAreaId': null
};

const DocumentsListFilter = ({ onFilter }) => {

    const [filterProps, setFilterProps] = useState(initialFilterProps);
    const [areaFilterValue, setAreaFilterValue] = useState(null);

    const handleClearFilters = () => {
        setFilterProps(initialFilterProps);
        setAreaFilterValue(null);
    };

    return (<Fragment>
        <Card>
            <CardHeader className='flex-md-row flex-column align-md-items-center align-items-start border-bottom'>
                <CardTitle tag='h4'>Documentos - Filtro de Búsqueda</CardTitle>
            </CardHeader>


            <Row className='mx-0' style={{ 'paddingTop': '2%', paddingLeft: '5%' }}>
                <Col className='d-flex align-items-center justify-content-sm-center justify-content-md-end mt-1' md='5' sm='12'>

                    <Label className='me-1' for='search-input' style={{ minWidth: '100px', 'display': 'inline-block', textAlign: 'right' }}>
                        Nombre de plantilla
                    </Label>
                    <Input
                        className='dataTable-filter mb-50 '
                        type='text'
                        bsSize='sm'
                        id='search-input'
                        value={filterProps.title}
                        onChange={(e) => setFilterProps({ ...filterProps, title: e.target.value })}
                    />
                </Col>

                <Col className='d-flex align-items-center justify-content-sm-center justify-content-md-end mt-1' md='5' sm='12'>

                    <Label className='me-1' for='search-input' style={{ minWidth: '100px', 'display': 'inline-block', textAlign: 'right' }}>
                        N° Documento de Identidad
                    </Label>
                    <Input
                        className='dataTable-filter mb-50'
                        type='text'
                        bsSize='sm'
                        id='search-input'
                        value={filterProps.clientIdentification}
                        onChange={(e) => setFilterProps({ ...filterProps, clientIdentification: e.target.value })}
                    />
                </Col>

            </Row>
            <Row className='mx-0' style={{ marginBlock: "1%", paddingLeft: '5%' }}>
                <Col className='d-flex align-items-center justify-content-sm-center justify-content-md-end mt-1' md='5' sm='12'>
                    <Label className='me-1' for='search-input' style={{ minWidth: '100px', 'display': 'inline-block', textAlign: 'right' }}>
                        Correo Electrónico
                    </Label>
                    <Input
                        className='dataTable-filter mb-50'
                        type='email'
                        bsSize='sm'
                        id='search-input'
                        value={filterProps.clientEmail}
                        onChange={(e) => setFilterProps({ ...filterProps, clientEmail: e.target.value })}
                    />
                </Col>
                {/*<Row className='justify-content-end mx-0' style={{marginBlock : "1%"}}>*/}
                <Col className='d-flex align-items-center justify-content-sm-center justify-content-md-end mt-1' md='5' sm='12'>
                    <Label className='me-1' for='search-input' style={{ minWidth: '100px', 'display': 'inline-block', textAlign: 'right' }}>
                        N° celular
                    </Label>
                    <Input
                        className='dataTable-filter mb-50'
                        type='text'
                        bsSize='sm'
                        id='search-input'
                        value={filterProps.clientPhone}
                        onChange={(e) => setFilterProps({ ...filterProps, clientPhone: e.target.value })}
                    />
                </Col>
            </Row>
            <Row className='mx-0' style={{ paddingLeft: '5%' }}>
                <Col className='d-flex align-items-center justify-content-sm-center justify-content-md-end mt-1' md='5' sm='12'>
                    <Label className='me-1' for='search-input' style={{ minWidth: '100px', 'display': 'inline-block', textAlign: 'right' }}>
                        Nombre de cliente
                    </Label>
                    <Input

                        className='dataTable-filter mb-50'
                        type='text'
                        bsSize='sm'
                        id='search-input'
                        value={filterProps.clientName}
                        onChange={(e) => setFilterProps({ ...filterProps, clientName: e.target.value })}
                    />
                </Col>

                <Col className='d-flex align-items-center justify-content-sm-center justify-content-md-end mt-1' md='5' sm='12'>
                    <AreaFilter
                        isMultiSelect={false}
                        onAreaChange={(selectedOptions) => {
                            setFilterProps({ ...filterProps, companyAreaId: selectedOptions?.value || null });
                            setAreaFilterValue(selectedOptions);
                        }}
                        valueList={areaFilterValue}
                    />
                </Col>
            </Row>
            <Row>
                <Col className='d-flex align-items-center justify-content-sm-center mx-2 my-3'>
                    <Button className='mx-2' style={{ size: "10px", 'width': "200px" }} color='primary' onClick={() => onFilter(filterProps)}>Búsqueda</Button>
                    <Button className='mx-2' style={{ size: "10px", 'width': "200px" }} color='primary' onClick={handleClearFilters}>Limpiar Filtros</Button>
                </Col>

            </Row>


        </Card>
    </Fragment>)
}

export default DocumentsListFilter;